module.exports = __webpack_public_path__ + "img/note-pad.a08da75d.svg";